'use client';

import { useSearchParams } from 'next/navigation';
import { useCallback, useRef } from 'react';
import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { ContestHeader2026 } from '@/app-components/promotions/ContestHeader2026';
import { TopUp } from '@/app-components/promotions/TopUp';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';
import { configure } from 'utils/configure';
import { ContentTab } from './components/ContentTab';
import { VoteTab } from './components/VoteTab';

const BASE_URL = `${configure.staticPrefix}/images/contests/4/vote`;

export const VotePage = ({ isApp }: { isApp?: boolean }) => {
  useInAppHeader({ screen: WebViewScreen.PickAndChoo, title: '2026 제 4회 픽앤츄' });
  useInAppStatusBar(WebViewScreen.PickAndChoo);
  const searchParams = useSearchParams();
  const activeTab = searchParams?.get('tab') || 'vote';
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClickTab = useCallback((tab: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set('tab', tab);
    window.history.replaceState(null, '', url.toString());
    document.getElementById('top')?.scrollIntoView();
  }, []);

  return (
    <MutableHeaderLayout title="2026 제 4회 픽앤츄" noBottomPadding isApp={isApp}>
      <ContestHeader2026 tab="vote" />
      <div ref={containerRef} id="vote-page-container" className="flex flex-col items-center w-full bg-white">
        <div className="relative w-full flex justify-center">
          <img alt="vote_1" src={`${BASE_URL}/1.webp`} className="w-full h-auto block" />
        </div>
        <div id="top" />
        <div className="flex justify-center bg-white w-full sticky top-0 z-40 cursor-pointer">
          <div
            className={`grow shrink basis-0 self-stretch px-[30px] py-[26px] pc:px-[60px] pc:py-[21px] bg-[#000000] justify-center items-center flex ${
              activeTab === 'vote' ? 'opacity-100' : 'opacity-60'
            }`}
            role="button"
            onClick={() => handleClickTab('vote')}>
            <div className="text-center text-white font-semibold text-xxs leading-[20px] pc:text-[22px] pc:leading-[30px]">
              픽앤츄 투표 방식 안내
            </div>
          </div>
          <div
            className={`grow shrink basis-0 self-stretch px-[30px] py-[26px] pc:px-[60px] pc:py-[21px] bg-[#000000] justify-center items-center flex ${
              activeTab === 'content' ? 'opacity-100' : 'opacity-60'
            }`}
            role="button"
            onClick={() => handleClickTab('content')}>
            <div className="text-center text-white font-semibold text-xxs leading-[20px] pc:text-[22px] pc:leading-[30px]">
              픽앤츄 작품 보러 가기
            </div>
          </div>
        </div>
        {activeTab === 'vote' && <VoteTab />}
        {activeTab === 'content' && <ContentTab />}
        <TopUp />
      </div>
    </MutableHeaderLayout>
  );
};
